package com.nonopn.geolocation

data class LatLng(
    val latitude: Double,
    val longitude: Double,
)

data class Azimuth(
    val degrees: Float,
    val accuracy: Float?,
)

data class Speed(
    val mps: Float,
    val accuracy: Float?,
)

data class Altitude(
    val meters: Double,
    val accuracy: Float?,
)

data class Location(
    val coordinates: LatLng,
    val accuracy: Double,
    val azimuth: Azimuth?,
    val speed: Speed?,
    val altitude: Altitude?,
    val timestampMillis: Long,
)
